import { useVideoStatusDescriptionModel } from './video-status-description.model'
import type { IVideoStatusDescription } from './video-status-description.types'
import { VideoStatusDescriptionView } from './video-status-description.view'

export const VideoStatusDescription = (props: IVideoStatusDescription) => {
  const videoStatusModel = useVideoStatusDescriptionModel(props)

  return <VideoStatusDescriptionView {...videoStatusModel} />
}
